import { serviceError, serviceSuccess } from '@/contexts/shared/service-response/ServiceResponse.helpers'
import { useApi } from '@/contexts/shared/api/UseApi.composables'
import type { IntercomJwt } from '@/contexts/users/User.interfaces'
import type { RestAPIIntercomToken } from '@/interfaces/ApiRest.generated.interfaces'
import type { ServiceResponse } from '@/contexts/shared/service-response/ServiceResponse.interfaces'

export const getIntercomToken = async (): Promise<ServiceResponse<IntercomJwt>> => {
  const url = '/v2/users/intercom/token'
  const { ok, code, data: response } = await useApi.post<RestAPIIntercomToken>(url)

  if (!ok) {
    return serviceError(code)
  }

  return serviceSuccess({ jwt: response.token })
}
